export default {
  allServiceObservations: [],
}
